import React, { useState, useEffect } from "react";
import theme from "../../../../Styles/theme";
import Modal from "react-modal";
import { Container,  } from "./styles";
import { ModalDivX } from "../../../ModalDivX";
import api from "../../../../Services/api";
import { ModalLoader } from "../../../ModalLoader";
import { Alert } from "../../../Error/Alert";
import { Paperclip, Plus } from "react-feather";
import { IAnexos } from "..";
import { Button } from "./styles";
import { Title } from "../styles";
import { useFuncionarioCartorio } from "../../../../Hooks/funcionarioCartorio";
import { useCartorio } from "../../../../Hooks/cartorio";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: theme.colors.secondary,
    minWidth: "40%",
    maxWidth: "80%",
    borderRadius: "0.25rem",
  },
};

interface Props {
  open: boolean;
  onClose(): void;
  anexo: IAnexos;
  handleRemoveAnexo(): void;
}

export function RemoverAnexoModal({ open, onClose, anexo, handleRemoveAnexo }: Props) {
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({ message: "", title: "" });

  const { cartorioIsLogged, cartorio, checarToken } = useCartorio();
  const {
    funcionarioCartorioIsLogged,
    checarTokenFuncionario,
  } = useFuncionarioCartorio();
 

  async function post() {
  
      try {
        setLoading(true);
        if (funcionarioCartorioIsLogged) {
            await checarTokenFuncionario();
          }
    
          if (cartorioIsLogged) {
            await checarToken();
          }
       await api.delete(`/imovel-anexos/${anexo.IDENTIFICADOR}`);
        handleRemoveAnexo();
        onClose();
      } catch (error) {
        setError({
          title: "Não foi possível excluir o anexo!",
          message:
            "Ocorreu um erro durante a exclusão do anexo, tente novamente!",
        });
      } finally {
        setLoading(false);
      }
  }

  return (
    <>
      <Modal isOpen={open} onRequestClose={onClose} style={customStyles}>
        <ModalDivX execute={onClose} />

        <Container>
          <Title>
              Tem certeza que deseja excluir o anexo: <strong>{anexo.TITULO}</strong>?
          </Title>
          <Button onClick={post}>CONFIRMAR</Button>
        </Container>
      </Modal>
      <ModalLoader loading={loading} />
      <Alert
        message={error.message}
        title={error.title}
        open={error.message.length > 0}
        onClose={() => setError({ message: "", title: "" })}
      />
    </>
  );
}
